module.exports = {
  MOCKCMD_SENDTOBOT: 'MOCKCMD_SENDTOBOT',
  MOCKCMD_RECEIVEDFROMBOT: 'MOCKCMD_RECEIVEDFROMBOT'
}
